import { Icon } from "PFComponents/icon";
import { Activity } from "PFTypes";
import { useTranslation } from "react-i18next";

import { DetailsHeader } from "../details_header";

type MisalignmentsHeaderProps = {
  activities: Activity[];
};

export const MisalignmentsHeader = ({ activities }: MisalignmentsHeaderProps) => {
  const { t } = useTranslation("bookingModule", { keyPrefix: "details.misalignments" });

  const subtitle = activities.length > 1 ? t("rolesCount", { count: activities.length }) : activities[0].name;

  return (
    <DetailsHeader title={t("title")} subtitle={subtitle}>
      <Icon name="role" color="paletteBlue0" />
    </DetailsHeader>
  );
};
